import React from "react";
import AboutSideImage from "../../assets/images/about/about Girl 0.1.jpg";
import about_girl from "../../assets/about_girl.png"
export default function OurStory() {
  return (
    <div className="bg-[#deecdd] relative min-h-screen flex flex-col px-0 md:px-10 2xl:px-0">
      <div
        className="sm:max-w-full md:max-w-[80%] xl:max-w-[80rem] 3xl:max-w-[90rem] mx-auto flex-1 flex flex-col justify-between px-6 md:p-5 lg:p-0"
        data-aos="fade-up"
      >
        <div className="">
          <h1
            className="text-[#29562f] uppercase sm:text-2xl text-[2.5rem] md:text-[4rem] md:mb-10 font-light md:font-extralight font-lexend "
            data-aos="fade-up"
            data-aos-delay="100"
          >
            Our story
          </h1>
          <p
            className="md:w-[85%] w-[95%]  md:py-0 pt-3 text-left text-[#333333] font-light font-lexend sm:text-[14px] text-base xs:text-[12px] md:text-[18.5px]"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            We live in a world that's always on the move. We've normalised the
            hustle, glorified the grind, and learnt to laugh at how little time
            we have. But in this race to keep up, something vital is quietly
            fading away-the quality of our rest.
          </p>
          <h2
            className="sm:text-[18px] xs:text-[15px] md:text-[2.1rem] sm:text-base text-lg text-[#29562f] my-5 font-light font-lexend"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            Moondew is here to help you pause.
          </h2>
          <p
            className="md:w-[90%]  md:block hidden text-left text-[#333333] font-light font-lexend sm:text-[14px] text-base xs:text-[12px] md:text-[18.5px]"
            data-aos="fade-up"
            data-aos-delay="400"
          >
            Born out of a desire to bring clarity, care, and heart to the
            mattress industry, Moondew is reimagining what rest means for the
            modern Indian. <br /> Where others sell mattresses, we craft sleep
            experiences rooted in trust and transparency -from the materials we
            source to the stories we share.
          </p>
          <p
            className="md:w-[90%] w-[95%] text-left block md:hidden text-[#333333] font-light font-lexend sm:text-[14px] text-base xs:text-[12px]"
            data-aos="fade-up"
            data-aos-delay="400"
          >
            Born out of a desire to bring clarity, care, and heart to the
            mattress industry, Moondew is reimagining what rest means for the
            modern Indian.Where others sell mattresses, we craft sleep
            experiences rooted in trust and transparency -from the materials we
            source to the stories we share.
          </p>
        </div>

        <div className="grid xl:grid-cols-[40%_60%] mt-8 md:mt-16 gap-0 flex-1 grid-cols-1  bg-[#29562f]  justify-center items-center ">
          <div data-aos="fade-right" data-aos-delay="100">
            <img
              src={AboutSideImage}
              alt=""
              className="w-full md:block hidden h-auto lg:h-[700px] object-cover"
            />
            <img
              src={about_girl}
              alt=""
              className="w-full block md:hidden h-auto  object-cover"
            />
          </div>
          <div className="  font-light font-lexend text-white sm:text-sm text-lg md:text-[2rem] leading-normal lg:py-0 md:py-28 py-10">
            <h4 className="w-full xl:w-[60%] mx-auto px-6 md:p-7 xl:p-0 md:text-left text-center" data-aos="fade-left"
            data-aos-delay="100">
              Each Moondew mattress is a reflection of the people we serve-urban
              dwellers juggling demanding careers, sedentary routines, and the
              constant rush of life. For them sleep isn't just a break; it's a
              reset. That's why our range is designed not just for comfort, but
              for conscious living.
            </h4>
          </div>
        </div>
      </div>
    </div>
  );
}
